/* Caesar — interaction layer.
   1. --k: artboard scale so each desktop section fits one viewport (Figma frames are 1440×900).
   2. Kit panel reveal over the fun-fact section: --reveal (width), --rise (content lifts in), --round (corners held).
   3. Cursor tilt on the Pick-your-Caesar cards.
   4. Product section: thumbnails swap the background photo; accordion opens one row at a time.
   Floating pills / drifting cards / flip cards are pure CSS. Add-to-cart is a normal Shopify form post. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---- 1. artboard scale ---- */
  function setScale() {
    var k = Math.min(window.innerWidth / 1440, window.innerHeight / 900);
    var forced = /[?&]k=([\d.]+)/.exec(location.search);            // ?k=0.87 — QA aid for full-page captures
    if (forced) k = parseFloat(forced[1]);
    k = Math.max(0.5, Math.min(1.35, k));
    root.style.setProperty('--k', k.toFixed(4));
  }
  setScale();

  /* ---- 2. kit reveal ---- */
  var kit = document.querySelector('.kit');
  var last = -1;
  function ease(t) { return t * t * (3 - 2 * t); }
  function update() {
    if (!kit) return;
    var rect = kit.getBoundingClientRect();
    var vh = window.innerHeight;
    var p = (vh - rect.top) / (vh * 0.7);
    p = Math.max(0, Math.min(1, p));
    if (reduce || window.innerWidth <= 960) p = 1;
    if (p === last) return;
    last = p;
    kit.style.setProperty('--reveal', ease(p).toFixed(4));
    kit.style.setProperty('--rise', (1 - ease(Math.min(1, p / 0.85))).toFixed(4));
    kit.style.setProperty('--round', (1 - ease(Math.max(0, (p - 0.85) / 0.15))).toFixed(4));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setScale(); last = -1; onScroll(); });
  update();

  /* ---- 3. card tilt ---- */
  if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.stage-card').forEach(function (card) {
      var max = 9;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--rx', (-y * max).toFixed(2) + 'deg');
        card.style.setProperty('--ry', (x * max).toFixed(2) + 'deg');
        card.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(1) + '%');
        card.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(1) + '%');
        card.classList.add('is-tilting');
      });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }
  document.querySelectorAll('.stage-card, .step-card').forEach(function (c, i) { c.style.setProperty('--i', i % 3); });

  /* ---- 3b. nav BUY NOW appears once the hero's has scrolled away ---- */
  var heroCta = document.querySelector('.hero__cta'), navSec = document.querySelector('.sec-nav');
  if (heroCta && navSec && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      navSec.classList.toggle('is-past-hero', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(heroCta);
  } else if (navSec) { navSec.classList.add('is-past-hero'); }

  /* ---- 3c. product section is sized once for its tallest state (the largest accordion row open), so the
          background photo never jumps when a row opens. Rows are opened one at a time off-screen to measure. ---- */
  var detail = document.querySelector('.detail'), detailArt = document.querySelector('.art--detail');
  if (detail && detailArt) {
    var card = detailArt.querySelector('.detail-card');
    var fit = function () {
      if (window.innerWidth <= 960) { detail.style.removeProperty('--h'); return; }
      var rows = card.querySelectorAll('.accordion__item');
      var was = [].map.call(rows, function (d) { return d.open; });
      card.classList.add('is-measuring');
      rows.forEach(function (d) { d.open = false; });
      var max = card.offsetHeight;
      rows.forEach(function (d) { d.open = true; max = Math.max(max, card.offsetHeight); d.open = false; });
      rows.forEach(function (d, i) { d.open = was[i]; });
      card.classList.remove('is-measuring');
      detail.style.setProperty('--h', Math.ceil(max + 200));
    };
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('resize', fit);
  }

  /* ---- 3d. section reveal: content fades/rises in as each section enters the viewport (CSS does the motion) ---- */
  var revealSections = document.querySelectorAll('.hero, .funfact, .kit, .stages, .detail, .howto, .footer, .legal');
  if (revealSections.length && !reduce && 'IntersectionObserver' in window) {
    root.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealSections.forEach(function (s) { io.observe(s); });
  }

  /* ---- 4a. thumbnails swap the product-section photo ---- */
  var photo = document.querySelector('.detail__photo');
  var thumbs = document.querySelectorAll('.detail__thumb');
  if (photo && thumbs.length) {
    photo.dataset.original = photo.currentSrc || photo.src;
    thumbs.forEach(function (t) {
      var btn = t.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        var active = t.classList.contains('is-active');
        thumbs.forEach(function (o) { o.classList.remove('is-active'); });
        if (active) {                                   // second click restores the default photo
          photo.srcset = ''; photo.src = photo.dataset.original;
        } else {
          t.classList.add('is-active');
          photo.srcset = ''; photo.src = full;
        }
      });
    });
  }

  /* ---- 4b. accordion: one row open at a time ---- */
  document.querySelectorAll('.accordion').forEach(function (acc) {
    acc.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      acc.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
})();
